<div class="layout-footer">
    <div class="footer-logo-container">
        <img id="footer-logo" [src]="'assets/layout/images/logo-'+ (app.colorScheme === 'light' ? 'dark' : 'white') + '.svg'" alt="SmartBox"/>
        <span class="app-name">SmartBox</span>
    </div>
    <span class="copyright">&#169; SmartFactory d.o.o. - 2026 | Version: {{version}}</span>
</div>
